import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

//导入 JsBridge.js
// Vue.prototype.$bridge = Bridge ;

//引入字体库
import "./assets/css/style.css";

//全局注册filter
import filters from "./assets/js/filter";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

//引入amfe-flexible
import "amfe-flexible/index";

//引入vant组件
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);

//导入config配置项
// import { ONLINE } from "./config/config";

//导入请求类
import Request from "./utils/request";
import NativeUtil from "./utils/JSBridge/NativeUtil";
import conditionMethod from "./utils/conditionMethod";

//全局配置
Vue.prototype.$utils = Request;
Vue.prototype.$nativeUtil = NativeUtil;
Vue.prototype.$request = Request.sendRequest;
// Vue.prototype.$online = ONLINE;
Vue.prototype.$condition = conditionMethod;

//引入axios
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
